import React from 'react';
import { SvgIcon } from '@mui/material';

export default function PlayIcon(props) {
  return (
    <SvgIcon viewBox="0 0 27 28" sx={{ width: 27, height: 28 }} {...props}>
      <path
        d="M25.8528 12.2318C27.2736 12.9826 27.2736 15.0176 25.8528 15.7684L3.81363 27.4144C2.48168 28.1182 0.879218 27.1526 0.879218 25.6461L0.879219 2.35406C0.879219 0.847594 2.48168 -0.118067 3.81363 0.585762L25.8528 12.2318Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
